import { BottomSheet } from "react-spring-bottom-sheet";
import Popup from "reactjs-popup";
import styled from "@emotion/styled";

export const BottomSheetCustomizado = styled(BottomSheet)`
  [data-rsbs-overlay] {
    background: ${(props) => props.theme.cores.surface2};
    display: flex !important;
    flex-direction: column;
  }

  [data-rsbs-content] {
    padding: 4px 24px 0 24px;
    display: block !important;
  }
`;

export const PopupCustomizado = styled(Popup)`
  &-content {
    width: ${({ $width }) => $width || "auto"} !important;
    border-radius: 24px;
    padding: 24px;
    background-color: ${({ theme }) => theme.cores.surface2};
    border: none;
    max-width: ${({ $maxWidth }) => $maxWidth};
    max-height: 85vh;
    display: flex;
    flex-direction: column;
    position: relative;
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
      background: ${(props) => props.theme.cores.brand20};
    }

    &::-webkit-scrollbar-track {
      background: ${(props) => props.theme.cores.brand20};
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
      background: ${(props) => props.theme.cores.actionActive};
      border-radius: 10px;
    }

    &::-webkit-scrollbar-button {
      display: none;
      width: 0;
      height: 0;
    }

    &::-webkit-scrollbar-button:single-button {
      display: none;
      width: 0;
      height: 0;
    }

    &::-webkit-scrollbar-button:vertical:start:decrement,
    &::-webkit-scrollbar-button:vertical:end:increment,
    &::-webkit-scrollbar-button:horizontal:start:decrement,
    &::-webkit-scrollbar-button:horizontal:end:increment {
      display: none;
      width: 0;
      height: 0;
    }

    &::-webkit-scrollbar-corner {
      background: transparent;
    }

    @media (max-width: 1100px) {
      ${({ $modoPopUpBannerInformativo }) =>
    $modoPopUpBannerInformativo &&
    `
          position: absolute !important;
          top: 0 !important;
          max-height: 90vh !important;
          border-radius: 8px !important;
          width: 100% !important;
        `}
    }
  }
`;

export const OverlayManual = styled.div`
  position: fixed;
  z-index: 2;
  top: 0;
  left: 0;
  width: 100vw;
  height: 150vh;
  background-color: rgba(0, 0, 0, 0.6);
  //background-color: var(--rsbs-backdrop-bg, rgba(0, 0, 0, 0.6));
  will-change: opacity;
  cursor: pointer;
  animation: fadeIn 400ms ease-in-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;
